module.exports = __webpack_public_path__ + "static/media/logoradio.5c5cf8d2.png";